import React from "react";
import AcquireWebComponent from "../framework/MaterialUI";
import Dialog from "material-ui/Dialog";
import isEmpty from "lodash/isEmpty";

class ActivateAudienceDialog extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      subject: props.segment_summary
        ? "Activate " + props.segment_summary.name
        : "",
      comments: "",
    };
  }

  submitActivation() {
    this.props.submitActivateRequest(
      this.props.segment_summary.id,
      this.props.segment_summary.clientId,
      this.state.subject,
      this.state.comments,
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.request_success !== this.props.request_success &&
      this.props.request_success === true
    ) {
      this.props.onRequestActivationClose();
    }
  }
  render() {
    return (
      <Dialog
        title={"Activate Audience"}
        modal={false}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={true}
        titleStyle={{ fontWeight: "bold", fontSize: "24px", padding: "20px" }}
        open={this.props.open}
        onRequestClose={() => {
          this.props.onRequestActivationClose();
        }}
        bodyStyle={{
          color: "#000",
          fontWeight: "normal",
          fontSize: "16px",
          paddingTop: "0px",
          paddingBottom: "20px",
          textAlign: "left",
          overflowY: "auto",
          height: "1080px",
          borderTop: "solid 0px #EEEFF2",
        }}
        contentStyle={{
          width: "960px",
          maxWidth: "960px",
          height: "1080px",
        }}
      >
        <div>
          <div
            style={{
              paddingBottom: "20px",
              marginBottom: "20px",
              borderBottom: "solid 1px #EEEFF2",
            }}
          >
            Claritas can help you activate and target your audiences across both
            offline and online channels. We offer multiple delivery paths to
            support your business needs:
          </div>
          <div className="pt-20" style={{ display: "flex" }}>
            <div style={{ width: "280px", borderRight: "solid 1px #EEEFF2" }}>
              <div>
                <strong>Claritas Full Campaign Execution</strong>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ padding: " 20px 10px 20px 0px" }}>
                  <img src="/images/claritas-email-logo.png" alt="" />
                  <div className="pt-10 text-center">
                    <strong>Email</strong>
                  </div>
                </div>
                <div style={{ padding: " 20px 10px 0px" }}>
                  <img src="/images/claritas-social-logo.png" alt="" />
                  <div className="pt-10 text-center">
                    <strong>Social</strong>
                  </div>
                </div>
                <div style={{ padding: " 20px 0px 20px 10px" }}>
                  <img src="/images/claritas-display-logo.png" alt="" />
                  <div className="pt-10 text-center">
                    <strong>Display</strong>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: "600px", marginLeft: "20px" }}>
              <div className="text-center">
                <strong>
                  Claritas can provide audiences for campaign execution:
                </strong>
              </div>
              <div
                style={{
                  borderBottom: "solid 1px #EEEFF2",
                  paddingBottom: "20px",
                  paddingTop: "20px",
                  display: "flex",
                }}
              >
                <div style={{ width: "75px" }}>
                  <strong>Email - </strong>
                </div>
                <div>
                  Under certain circumstances, we will deliver active email
                  addresses for campaign execution
                </div>
              </div>
              <div
                style={{
                  borderBottom: "solid 1px #EEEFF2",
                  paddingBottom: "20px",
                  paddingTop: "20px",
                }}
              >
                <strong>Social - </strong> We onboard audiences to your social
                platform of choice
              </div>
              <div
                style={{
                  borderBottom: "solid 1px #EEEFF2",
                  paddingBottom: "20px",
                  paddingTop: "20px",
                }}
              >
                <strong>Display - </strong> We deliver audiences to your
                platform of choice for programmatic buying
              </div>
              <div
                style={{
                  paddingBottom: "20px",
                  paddingTop: "20px",
                }}
              >
                <strong>Direct Mail - </strong> We deliver full name and postal
                addresses of your audience
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              paddingTop: "20px",
              paddingBottom: "20px",
              borderTop: "solid 1px #EEEFF2",
              textAlign: "center",
            }}
          >
            Find PRIZM® Premier , P$YCLE® Premier , and ConneXions® segments
            available today across our vast digital partner network:
          </div>
          <div style={{ display: "flex", marginTop: "40px" }}>
            <div style={{ width: "150px" }}>&nbsp;</div>
            <div style={{ width: "180px" }}>
              <img src="/images/liveRamp-logo.png" alt="" />
            </div>
            <div style={{ width: "160px" }}>
              <img src="/images/google-logo.png" alt="" />
            </div>
            <div style={{ width: "140px" }}>
              <img src="/images/oauth-logo.png" alt="" />
            </div>
            <div style={{ width: "150px" }}>
              <img src="/images/adobe-logo.png" alt="" />
            </div>
            <div style={{ width: "10%" }}>&nbsp;</div>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "40px",
              paddingBottom: "20px",
              borderBottom: "solid 1px #EEEFF2",
            }}
          >
            <div style={{ width: "180px" }}>&nbsp;</div>
            <div style={{ width: "250px" }}>
              <img src="/images/theTradeDesk-logo.png" alt="" />
            </div>
            <div style={{ width: "170px", marginTop: "-10px" }}>
              <img src="/images/mediaMath-logo.png" alt="" />
            </div>
            <div style={{ width: "150px" }}>
              <img src="/images/oracle-logo.png" alt="" />
            </div>
            <div style={{ width: "10%" }}>&nbsp;</div>
          </div>
          <div style={{ padding: "20px 0 0" }}>
            <div className="text-center">
              <strong>Contact us to discuss options and next steps</strong>
            </div>
            <div style={{ display: "flex", padding: "20px 0" }}>
              <div style={{ width: "100px" }}>
                <strong>Subject</strong>
              </div>
              <div style={{ width: "780px" }}>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    border: "solid 1px",
                    padding: "10px",
                  }}
                  value={this.state.subject}
                  maxLength="65"
                  onChange={e => {
                    this.setState({ subject: e.target.value });
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", padding: "10px 0 20px" }}>
              <div style={{ width: "100px" }}>
                <strong>Comments</strong>
              </div>
              <div style={{ width: "780px" }}>
                <textarea
                  className="comment-box"
                  rows="6"
                  style={{
                    width: "100%",
                    padding: "10px",
                    overflowY: "auto",
                  }}
                  value={this.state.comments}
                  maxLength="500"
                  onChange={e => {
                    this.setState({ comments: e.target.value });
                  }}
                />
              </div>
            </div>
          </div>
          <div style={{ textAlign: "right", paddingRight: "10px" }}>
            {this.props.request_error && (
              <div
                className="pull-left ml-20 mt-5"
                style={{ fontWeight: "bold", color: "#FF0000" }}
              >
                {this.props.request_error}
              </div>
            )}

            <button
              className="btn "
              onClick={() => {
                this.props.onRequestActivationClose();
              }}
            >
              Cancel
            </button>
            <button
              disabled={
                isEmpty(this.state.comments) || isEmpty(this.state.subject)
              }
              className="btn btn-claritas-default ml-20 mr-20"
              onClick={this.submitActivation.bind(this)}
            >
              Submit
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default ActivateAudienceDialog;



// WEBPACK FOOTER //
// ./src/components/NewSegmentDetail/ActivateAudienceDialog.jsx